import AddressFormatterFunctional from 'src/components/Layouts/AddressFormatterFunctional';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'nit',
      label: i18n.t('common_words.nit'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'phone',
      label: i18n.t('common_words.phone'),
      show: false,
    },
    {
      prop: 'email',
      label: i18n.t('common_words.email'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'tradename',
      label: i18n.t('common_words.comercial_name'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'web_site',
      label: i18n.t('common_words.website'),
      show: false,
    },
    {
      prop: 'comercial_activity',
      label: i18n.t('common_words.comercial_activity'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'address',
      label: i18n.t('common_words.ubication'),
      minWidth: 200,
      sortable: true,
      formatter: AddressFormatterFunctional,
      address: true,
    },
    {
      prop: 'business_contacts',
      label: i18n.t('common_words.contacts'),
      show: false,
      contact: true,
    },
  ];

  return { tableColumns };
};

export default configTable;
